require('./cardSecurePaymentSuccessStep.scss');

const PropTypes = require('prop-types');

// @ vendor
const React = require('react');
// @ commons
const { FormattedText, formatText } = require('core/i18n').i18n;
const { formatCardNumber } = require('utilities/cardsHelper');
const { CommercialAds } = require('components/commons/commercialAds/commercialAds');
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
// @ constants
const { FIRST_STEP } = require('constants/index');
const { ECOMMERCE_KEY, ECOMMERCE_INTERNET_PAYMENTS_ADHERED } = require('constants/flagBasedFeatures');

class CardSecurePaymentSuccessStep extends React.Component {

    getSuccessTitleKey() {
        const { immCardSecurePayment, immFlagBasedFeatures } = this.props;
        const isSecureCommerceChecked = immCardSecurePayment.get('steps').get(FIRST_STEP).get('isSecureCommerceChecked');
        const isNoSecureCommerceChecked = immCardSecurePayment.get('steps').get(FIRST_STEP).get('isNoSecureCommerceChecked');
        let successTitleKey;
        
        if (immFlagBasedFeatures.get(ECOMMERCE_INTERNET_PAYMENTS_ADHERED) && immFlagBasedFeatures.get(ECOMMERCE_KEY)) {
            if (isNoSecureCommerceChecked) {
                successTitleKey = 'cardSecurePayment-cardSecurePayment_successStepCESWithPayment';
            } else {
                successTitleKey = 'cardSecurePayment-cardSecurePayment_successStepCESWithoutPayment';
            }
        } else {
            if (isSecureCommerceChecked && isNoSecureCommerceChecked) {
                successTitleKey = 'cardSecurePayment-successStepBoothSelectedTitle';
            } else if (isSecureCommerceChecked) {
                successTitleKey = 'cardSecurePayment-successStepCESSelectedTitle';
            } else if (isNoSecureCommerceChecked) {
                successTitleKey = 'cardSecurePayment-successStepNoCESSelectedTitle';
            } else {
                successTitleKey = 'cardSecurePayment-successStepNoSelectedTitle';
            }
        }

        return successTitleKey;
    }

    render() {
        const { immCard, immFlagBasedFeatures } = this.props;
        const cardAlias = immCard.get('alias').get('current');
        const title = formatText(this.getSuccessTitleKey(), [formatCardNumber(immCard.get('number'), 4, '*')]);
        const goBackButtonLabel = formatText('cardSecurePayment-successStepBackToCardLink', [cardAlias]).toUpperCase();
        const linkToDetails = `/myprofile/cards/${immCard.get('cardId')}/details`;
        const goBackButton = {
            label: goBackButtonLabel,
            url: linkToDetails
        }

        let successMessageText;

        if (immFlagBasedFeatures.get(ECOMMERCE_INTERNET_PAYMENTS_ADHERED) && immFlagBasedFeatures.get(ECOMMERCE_KEY)) {
            successMessageText = (
                <FormattedText
                    avoidTargetBlank={true}
                    className="card-secure-payment-success__text"
                    value="cardSecurePayment-cardSecurePayment_checkOrModfifyCESAnyTime"
                />
            );
        } else {
            successMessageText = (
                <FormattedText
                    value="cardSecurePayment-successStepText"
                    className="card-secure-payment-success__text"
                />
            );
        }

        return (
            <section className="card-secure-payment-success">
                <WizardSuccess
                    successMessage={title}
                    mainButton={goBackButton}
                >
                    <section className="card-secure-payment-success__content row">
                        <div className="col-xs-7 col-md-6">
                            <CommercialAds path="cards" type="cards" immCard={immCard} size="medium" />
                        </div>
                        <div className="col-xs-5 col-md-6">
                            {successMessageText}
                        </div>
                    </section>
                </WizardSuccess>
            </section>
        );
    }
}

CardSecurePaymentSuccessStep.propTypes = {
    immCard: PropTypes.object,
    immCardSecurePayment: PropTypes.object,
    immFlagBasedFeatures: PropTypes.object,
};

module.exports = CardSecurePaymentSuccessStep;